import * as rd from '@devexperts/remote-data-ts'

import { useAppSelector } from '@/hooks/store'
import { bookingAvailabilitySlice } from '@/store/bookingAvailabilitySlice'
import { cartSlice } from '@/store/cartSlice/index.ts'
import { reservationPricesSelector } from '@/store/cartSlice/selectors/reservationPricesSelector.ts'
import { servicesWithCartQuantitySelector } from '@/store/cartSlice/selectors/servicesWithCartQuantitySelector'
import { extraSlice } from '@/store/extraSlice'
import { licenseSlice } from '@/store/licenseSlice'
import {
  buildGaLineItemsFromBookingCart,
  type GaEcommerceLineItem,
} from '@/utils/analytics/ecommerceDataLayer'

export const useEcommerceItems = (): GaEcommerceLineItem[] => {
  const license = useAppSelector(licenseSlice.selectors.license)
  const cartReservations = useAppSelector(cartSlice.selectors.cartReservations)
  const servicesWithCartQuantity = useAppSelector(
    servicesWithCartQuantitySelector
  )
  const selectedBookingType = useAppSelector(
    cartSlice.selectors.selectedBookingType
  )
  const reservationPrices = useAppSelector(reservationPricesSelector)
  const bookingAvailability = useAppSelector(
    bookingAvailabilitySlice.selectors.self
  )
  const weatherInsurancePrice = useAppSelector(
    extraSlice.selectors.weatherInsurancePricePreview
  )

  const weatherInsurable =
    rd.isSuccess(weatherInsurancePrice) && weatherInsurancePrice.value > 0

  return buildGaLineItemsFromBookingCart({
    bookingAvailability,
    cartReservations,
    license,
    reservationPrices,
    selectedBookingType,
    servicesWithCartQuantity,
    weatherInsurable,
  })
}
